import { useRef } from "react";
import { Box } from "@chakra-ui/react";
import { useCursorGlow } from "../hooks/landingEffects";

const BackgroundFabric = () => {
  const glowRef = useRef(null);
  useCursorGlow(glowRef);

  return (
    <>
      <Box
        position="fixed"
        inset={0}
        zIndex={0}
        pointerEvents="none"
        sx={{
          background: `
            radial-gradient(900px 600px at 12% 8%, rgba(4,174,193,0.28), transparent 60%),
            radial-gradient(900px 600px at 92% 18%, rgba(99,102,241,0.28), transparent 65%),
            radial-gradient(700px 500px at 50% 92%, rgba(236,72,153,0.18), transparent 65%),
            #0a0e1a
          `,
        }}
      />

      <Box
        position="fixed"
        inset={0}
        zIndex={0}
        pointerEvents="none"
        opacity={0.18}
        sx={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.06) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.06) 1px, transparent 1px)
          `,
          backgroundSize: "56px 56px",
          maskImage:
            "radial-gradient(ellipse 80% 60% at 50% 30%, black, transparent 75%)",
          WebkitMaskImage:
            "radial-gradient(ellipse 80% 60% at 50% 30%, black, transparent 75%)",
        }}
      />

      <Box
        className="lp-blob"
        position="fixed"
        zIndex={0}
        pointerEvents="none"
        w="420px"
        h="420px"
        bg="#04aec1"
        borderRadius="50%"
        filter="blur(70px)"
        opacity={0.55}
        top="-100px"
        left="-120px"
        sx={{ animation: "lp-float 18s ease-in-out infinite" }}
      />
      <Box
        className="lp-blob"
        position="fixed"
        zIndex={0}
        pointerEvents="none"
        w="480px"
        h="480px"
        bg="#6366f1"
        borderRadius="50%"
        filter="blur(70px)"
        opacity={0.55}
        top="280px"
        right="-160px"
        sx={{
          animation: "lp-float 22s ease-in-out infinite",
          animationDelay: "-4s",
        }}
      />
      <Box
        className="lp-blob"
        position="fixed"
        zIndex={0}
        pointerEvents="none"
        w="380px"
        h="380px"
        bg="#ec4899"
        borderRadius="50%"
        filter="blur(70px)"
        opacity={0.4}
        bottom="-120px"
        left="40%"
        sx={{
          animation: "lp-float 26s ease-in-out infinite",
          animationDelay: "-9s",
        }}
      />

      <Box
        ref={glowRef}
        className="lp-cursor-glow"
        position="fixed"
        pointerEvents="none"
        zIndex={1}
        w="500px"
        h="500px"
        borderRadius="50%"
        sx={{
          background:
            "radial-gradient(circle, rgba(99,102,241,0.18), rgba(99,102,241,0) 60%)",
        }}
        transform="translate(-50%, -50%)"
        transition="transform 0.12s ease-out"
      />
    </>
  );
};

export default BackgroundFabric;
